import { CheckValue } from "../service";

export const setUserData = (el = {}) => {
  const role_name = el?.role_name || el?.role?.name || "";

  return {
    createdAt: el?.CreatedAt ?? null,
    updatedAt: el?.UpdatedAt ?? null,
    deletedAt: el?.DeletedAt ?? null,
    id: el?.id ?? el?.ID ?? null,
    name: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
    first_name: el?.first_name || "",
    last_name: el?.last_name || "",
    email: el?.email || "",
    title: el?.title || "",
    phone: el?.phone || "",
    note: el?.note || "",
    password: el?.password || "",
    hex_color: el?.hex_color || "",
    profile_pic: el?.profile_pic,
    role_id: CheckValue(el.role_id) ? String(el.role_id) : null,
    role_name,
  };
};